import React from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { sendSharedData } from "../Actions/SharedDataAction/SharedDataAction";

const PositionModal = ({ isOpen, onClose, user, positionList }) => {
  // console.log(user);
  const positions = [
    {
      id: 1,
      name: "HR",
      link: "http://localhost:3001/",
    },
    {
      id: 2,
      name: "Accounting",
    },
    {
      id: 3,
      name: "Development",
    },
    {
      id: 4,
      name: "Supply Chain",
    },
    {
      id: 5,
      name: "Medical",
      link: "http://localhost:3000/",
    },
    {
      id: 6,
      name: "Media",
    },
  ];

  const dispatch = useDispatch();
  const handleRoute = (link, name) => {
    dispatch(sendSharedData(link));
    localStorage.setItem("position", name);
  };
  return (
    <div className="text-center">
      <h1 className="text-xl text-center">Modal </h1>

      {positions?.map((position, index) => {
        return (
          <>
            {positionList.includes(position.id) && (
              <button
                onClick={() => handleRoute(position.link, position.name)}
                key={index}
                className="btn-indigo w-full   text-center"
              >
                <p className="text-center">{position.name}</p>
              </button>
            )}
          </>
        );
      })}
    
    </div>
  );
};

export default PositionModal;
